import { FILTERS } from '../filters/constants';
import { Filters } from '../filters/interfaces';
import { formatDateToApiFormat, UiDate } from '../../../constants/helpers/dates';
import { UrlParam, FetchOptions, RequestPaginationMarkers } from '../../../api/interfaces';
import {
  convertOptionsToUrlParam,
  convertArrayOptionsToUrlParam,
  convertPaginationOptionsToUrlParam
} from '../../../api/utils';

import { BillingApiOptions, CommonBillingFilters, GenericBillingFilters } from './interfaces';

export const convertBillingFiltersToUrlParam = ({ from, to, ...filtersProps }: GenericBillingFilters): UrlParam[] => {
  const filters = filtersProps as Record<string, string[]>;
  const urlFilterParam = convertArrayOptionsToUrlParam(filters);

  urlFilterParam.push([FILTERS.FROM, formatDateToApiFormat({ date: from })]);
  urlFilterParam.push([FILTERS.TO, formatDateToApiFormat({ date: to })]);

  return urlFilterParam;
};

const convertBillingApiOptionsToUrlParam = ({ totalCost }: BillingApiOptions): UrlParam[] => {
  const apiOptions = {
    total_cost: totalCost.toString()
  };

  return convertOptionsToUrlParam(apiOptions);
};

export const getQueryParams = ({
  filters,
  apiOptions,
  paginationOptions
}: {
  filters: CommonBillingFilters & Filters;
  apiOptions: BillingApiOptions;
  paginationOptions?: RequestPaginationMarkers;
}): FetchOptions => {
  const { page_size, ...otherFilters } = filters;

  const filtersParam: UrlParam[] = convertBillingFiltersToUrlParam(otherFilters);
  const apiOptionsParam: UrlParam[] = convertBillingApiOptionsToUrlParam(apiOptions);
  const paginationOptionsParam: UrlParam[] = convertPaginationOptionsToUrlParam({ page_size, ...paginationOptions });

  return { urlParams: [...filtersParam, ...apiOptionsParam, ...paginationOptionsParam] };
};

export const handleRefreshOptions = (
  refreshOptions: FetchOptions | undefined,
  activeToFilter: UiDate
): FetchOptions | undefined => {
  if (activeToFilter !== 'now' || !refreshOptions || !refreshOptions.urlParams) {
    return refreshOptions;
  }

  const { urlParams } = refreshOptions;

  const updatedUrlParams: UrlParam[] = urlParams.map(([key, value]: UrlParam) => {
    if (key === FILTERS.TO) {
      return [FILTERS.TO, formatDateToApiFormat({ date: activeToFilter })];
    }

    return [key, value];
  });

  return { urlParams: updatedUrlParams };
};
